<template>
  <div>
    <div style="text-align: left;" :class="menuFixed == true ? 'isFixed' :''">
      <el-row id="menu" style="background-color: #F0F0EE;">
        <el-col :xs="16" :sm="8" :md="8" :lg="10" style="background-color: #F0F0EE;">
          <el-button-group>
            <el-button v-if="hasBack" icon="el-icon-d-arrow-left" @click="goBack" style="background-color: #f3f3f4;"></el-button>
            <el-button icon="el-icon-s-home" @click="goHome" style="background-color: #e9e9ea;"></el-button>
            <el-button v-if="hasNext" icon="el-icon-d-arrow-right" @click="goNext" style="background-color: #f3f3f4;" :disabled="disableNext"></el-button>
          </el-button-group>
        </el-col>
        
        <el-col  class="hidden-md-and-down" :lg="3" style="text-align: center;background-color: #F0F0EE;">
          <slot name="title"></slot>
        </el-col>

        <el-col  class="hidden-xs-only" :sm="16" :md="16" :lg="11" style="text-align: right;background-color: #F0F0EE;">
          <slot name="button-group-right"></slot>
        </el-col>

        <el-col :xs="8" class="hidden-sm-and-up" style="text-align: right;background-color: #F0F0EE;">
          <slot name="button-group-right-toggle"></slot>
        </el-col>

      </el-row>
    </div>
    <div v-if="menuFixed" id='marginForMenu'>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'head-menu',
    props: {
      isHomePage: Boolean,
      hasBack: Boolean,
      hasNext: Boolean,
      disableNext: Boolean,
    },
    data() {
      return {
        menuFixed: false,
        offsetTop: 0,
      }
    },
    created() {
      window.addEventListener("scroll", this.handleScroll);//监听滑动事件
      window.addEventListener("resize", this.handleResize);//监听滑动事件
    },
    mounted() {
      this.offsetTop = document.querySelector('#menu').offsetTop
    },
    methods: {
      goHome() {
        if (this.isHomePage) {
          this.$router.go(0);
        } 
        else {
          this.$router.push({
            path: "/choose_city",
          });
          let lang = JSON.parse(sessionStorage.getItem("lang"));
          let user = JSON.parse(sessionStorage.getItem("User"));
          let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
          sessionStorage.clear();
          sessionStorage.setItem("lang", JSON.stringify(lang));
          sessionStorage.setItem("User", JSON.stringify(user));
          sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
        }
      },
      goBack() {
        this.$emit('go-back-click')
      },
      goNext() {
        this.$emit('go-next-click')
      },
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > this.offsetTop) {
          this.menuFixed = true
        } else {
          this.menuFixed = false
        }
      },
      handleResize() {
        this.offsetTop = document.querySelector('#menu').offsetTop
      }
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);//监听滑动事件
      window.removeEventListener("resize", this.handleResize);//监听滑动事件
    },
  }
</script>

<style lang="scss" scoped>
  .isFixed{
    @media (max-width:767px) {
      position:fixed;
      width: calc(100% - 40px);
      margin:0 20px;
      height: 40px;
      top:0;
      left: 0;
      z-index:999;
    }
  }

  #marginForMenu{
    @media (max-width:767px) {
      padding-top: 40px;
    }
  }

</style>


